import React, { Component } from 'react';
import services from '../../../services';
import $ from 'jquery'

class DropDownCellGraficas extends Component {


  GetAllGraficas(){
    
      (async () => {
          const data = {}
          const GraficasList = await services.apiCall.requestApi(
              "/Entidades/GetGraficas",
              data,
              "get"
          );

          if(GraficasList){

            var strHTML = "<option value='0' selected>Selecione...</option>";
            GraficasList.map((Grafica) => (


              strHTML += '<option value='+Grafica.codentidade+'>'+Grafica.nome+'</option>'

            ));

            $("#GraficaSelect").html(strHTML)

          }
      })();
      
  }

  componentDidMount = () => {

    (async () => {
      this.GetAllGraficas();
    })();

  }

  render() {

    return (
          <div className="col-md-12">
          <div className="input-box active-grey drop-down-box">
              <label className="input-label">
                Gráfica
              </label>
              <select class='custome-drop-down Grafica' name='grafica' id="GraficaSelect">                      
              </select>
          </div>
          </div>
    );
  }
}

export default DropDownCellGraficas;